interface RpcEnvelope<T> {
  data?: T;
  error?: string;
}

export async function rpc<T>(name: string, args: unknown[] = []): Promise<T> {
  const response = await fetch(`/api/rpc/${encodeURIComponent(name)}`, {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ args }),
  });
  const payload = await response.json() as RpcEnvelope<T>;
  if (!response.ok || payload.error) {
    throw new Error(payload.error || `Request failed with status ${response.status}.`);
  }
  return payload.data as T;
}
